export const appCdnURL = "https://cdn.delilegal.com/static/deli-web-portal-front/"

export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical","href":"https://www.delilegal.com"},{"rel":"alternate","hreflang":"zh-CN","href":"https://www.delilegal.com"},{"rel":"alternate","hreflang":"x-default","href":"https://www.delilegal.com"},{"rel":"dns-prefetch","href":"https://res.wx.qq.com"},{"rel":"dns-prefetch","href":"https://jic.talkingdata.com"},{"rel":"dns-prefetch","href":"https://web.cdn.openinstall.io"},{"rel":"preconnect","href":"https://res.wx.qq.com","crossorigin":"anonymous"}],"meta":[{"charset":"utf-8"},{"name":"referrer","content":"strict-origin-when-cross-origin"},{"http-equiv":"pragma","content":"no-cache"},{"http-equiv":"cache-control","content":"no-cache"},{"http-equiv":"expires","content":"0"},{"name":"viewport","content":"width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=5.0,user-scalable=yes"},{"name":"keywords","content":"得理门户网站,得理,法律AI,得理律助,得理法搜,法律科技,律师平台,DLS律师数字化平台,案例检索"},{"name":"description","content":"得理门户网站,得理,法律AI,得理律助,得理法搜,法律科技,律师平台,DLS律师数字化平台,案例检索"},{"name":"author","content":"得理科技"},{"name":"copyright","content":"© 得理科技 版权所有"},{"name":"robots","content":"index,follow"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"得理"},{"property":"og:title","content":"得理 - 法律行业智能化变革引领者"},{"property":"og:description","content":"得理门户网站,得理,法律AI,得理律助,得理法搜,法律科技,律师平台,DLS律师数字化平台,案例检索"},{"property":"og:url","content":"https://www.delilegal.com"},{"property":"og:image","content":"https://www.delilegal.com/favicon.ico"},{"property":"og:locale","content":"zh_CN"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"@delilegal"},{"name":"twitter:creator","content":"@delilegal"},{"name":"twitter:title","content":"得理 - 法律行业智能化变革引领者"},{"name":"twitter:description","content":"得理门户网站，法律行业智能化变革引领者。"},{"name":"twitter:image","content":"https://www.delilegal.com/favicon.ico"},{"name":"format-detection","content":"telephone=no,email=no,address=no"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"name":"apple-mobile-web-app-title","content":"得理"},{"name":"googlebot","content":"index,follow"},{"name":"bingbot","content":"index,follow"},{"name":"slurp","content":"index,follow"},{"name":"Baiduspider","content":"index,follow"},{"name":"360Spider","content":"index,follow"},{"name":"sogou","content":"index,follow"},{"name":"description","content":"得理门户网站，法律行业智能化变革引领者。提供法律AI、得理律助、得理法搜、法律科技、律师平台、DLS律师数字化平台、案例检索等专业服务。"},{"name":"keywords","content":"得理,法律AI,得理律助,得理法搜,法律科技,律师平台,DLS律师数字化平台,案例检索,法律服务,智能法律"},{"name":"author","content":"得理科技"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"name":"robots","content":"index,follow"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"得理"},{"property":"og:title","content":"得理 - 法律行业智能化变革引领者"},{"property":"og:description","content":"得理门户网站，提供法律AI、律师平台、案例检索等专业服务"},{"property":"og:image","content":"https://www.delilegal.com/favicon.ico"},{"property":"og:url","content":"https://www.delilegal.com"},{"property":"og:locale","content":"zh_CN"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"@deli"},{"name":"twitter:creator","content":"@deli"},{"name":"format-detection","content":"telephone=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"name":"apple-mobile-web-app-title","content":"得理"}],"style":[],"script":[{"type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"name\":\"得理\",\"description\":\"法律行业智能化变革引领者，提供法律AI、律师平台、案例检索等服务\",\"url\":\"https://www.delilegal.com\",\"logo\":\"https://www.delilegal.com/favicon.ico\",\"contactPoint\":{\"@type\":\"ContactPoint\",\"contactType\":\"customer service\",\"availableLanguage\":\"Chinese\"},\"sameAs\":[]}"},{"type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"WebSite\",\"name\":\"得理\",\"url\":\"https://www.delilegal.com\",\"description\":\"得理门户网站，法律行业智能化变革引领者\",\"inLanguage\":\"zh-CN\",\"potentialAction\":{\"@type\":\"SearchAction\",\"target\":\"https://www.delilegal.com/search?q={search_term_string}\",\"query-input\":\"required name=search_term_string\"}}"},{"src":"https://jic.talkingdata.com/app/h5/v1?appid=D6ACA3CF295340C1856F63A7D809C616&vn=production&vc=2.113.2","async":true},{"src":"https://web.cdn.openinstall.io/openinstall.js","async":true},{"src":"https://isz-app.sz.gov.cn:9043/iszStatic/sdk/jpasc-0.0.1.js","async":true},{"src":"https://g.alicdn.com/AWSC/AWSC/awsc.js","async":true}],"noscript":[],"title":"得理 - 法律行业智能化变革引领者","titleTemplate":"%s","htmlAttrs":{"lang":"zh-CN","dir":"ltr"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true